<div class="session-config-search relative mb-4">
	<mat-form-field appearance="outline" class="form-field-sm">
		<input
			matInput
			[(ngModel)]="searchQuery"
			[ngModelOptions]="{ standalone: true }"
			placeholder="Search"
			class="pr-10"
		/>
		<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
	</mat-form-field>
</div>

<div class="grid grid-cols-4 gap-x-16 gap-y-3">
	@for (col of filteredColumns; track $index) {
		<div class="flex flex-col gap-3">
			@for (s of col; track s.code) {
				<div class="flex flex-col gap-1">
					<mat-checkbox [formControl]="$any(sessions.get(s.code))" color="primary" [disabled]="readOnly">
						{{ s.description }}
					</mat-checkbox>
					@if (isSelected(s.code)) {
						<div class="pl-6 text-sm">
							@if (getRemarkPreview(s.code)) {
								<span class="text-grey-90">{{ getRemarkPreview(s.code) }}</span>
							} @else {
								<span class="italic text-grey-60">No details added</span>
							}
							@if (!readOnly) {
								<button
									type="button"
									class="ml-2 cursor-pointer border-0 bg-transparent p-0 text-sm text-red underline"
									(click)="openRemarkEditor(s)"
								>
									Edit
								</button>
							}
						</div>
					}
				</div>
			}
		</div>
	}
</div>
